export default __webpack_public_path__ + "static/media/view-inicial.787c6431.jpg";